__turbopack_context__.v({
  "circle": "HotSpots-module__IBAQUa__circle",
  "contentWrapper": "HotSpots-module__IBAQUa__contentWrapper",
  "hotSpotBlur": "HotSpots-module__IBAQUa__hotSpotBlur",
  "hotSpotClose": "HotSpots-module__IBAQUa__hotSpotClose",
  "hotSpotInput": "HotSpots-module__IBAQUa__hotSpotInput",
  "hotSpotLabel": "HotSpots-module__IBAQUa__hotSpotLabel",
  "hotSpotModal": "HotSpots-module__IBAQUa__hotSpotModal",
  "hotSpotWrapper": "HotSpots-module__IBAQUa__hotSpotWrapper",
  "hotspot__Overlay": "HotSpots-module__IBAQUa__hotspot__Overlay",
  "legend": "HotSpots-module__IBAQUa__legend",
  "modalInput": "HotSpots-module__IBAQUa__modalInput",
  "pulse": "HotSpots-module__IBAQUa__pulse",
  "pulse-animation": "HotSpots-module__IBAQUa__pulse-animation",
});
